import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs';
import { TuiDayRange } from '@taiga-ui/cdk';
import { BaseResizableComponent } from '@src/app/modules/base';
import { fixRouteParam } from '@src/utils';

import { LoyaltyProgramApiService, LpStatisticsService } from '../services';

import { DISCOUNT_CAPTIONS, PRODUCT_CAPTIONS } from './constants';

@Component({
  selector: 'app-lp-all-statistics',
  templateUrl: './lp-all-statistics.component.html',
  styleUrls: ['./lp-all-statistics.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LpAllStatisticsComponent extends BaseResizableComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly lpStatisticsService = inject(LpStatisticsService);
  private readonly lpApiService = inject(LoyaltyProgramApiService);

  statisticsSummary$ = this.lpStatisticsService.statisticsSummary$;
  statisticsSummaryLoading = true;

  statisticsBar$ = this.lpStatisticsService.statisticsBar$;
  statisticsBarLoading = true;

  statisticsProducts$ = this.lpStatisticsService.statisticsProducts$;
  statisticsProductsLoading = true;
  readonly productCaptions = PRODUCT_CAPTIONS;

  statisticsDiscounts$ = this.lpStatisticsService.statisticsDiscounts$;
  statisticsDiscountsLoading = true;
  readonly discountCaptions = DISCOUNT_CAPTIONS;

  unionId?: string;

  private productId?: string;

  override ngOnInit(): void {
    super.ngOnInit();

    this.statisticsSummary$
      .pipe(takeUntil(this.destroyed$$))
      .subscribe(value => (this.statisticsSummaryLoading = value === null));
    this.statisticsBar$
      .pipe(takeUntil(this.destroyed$$))
      .subscribe(value => (this.statisticsBarLoading = value === null));
    this.statisticsProducts$
      .pipe(takeUntil(this.destroyed$$))
      .subscribe(value => (this.statisticsProductsLoading = value === null));
    this.statisticsDiscounts$
      .pipe(takeUntil(this.destroyed$$))
      .subscribe(value => (this.statisticsDiscountsLoading = value === null));

    this.route.paramMap.pipe(takeUntil(this.destroyed$$)).subscribe(async params => {
      this.productId = fixRouteParam(params.get('loyaltyId'));

      this.route.queryParamMap.pipe(takeUntil(this.destroyed$$)).subscribe(async queryParams => {
        this.unionId = fixRouteParam(queryParams.get('unionId'));

        this.lpStatisticsService.startStatisticsSummary({
          productId: this.productId,
          unionId: this.unionId,
        });
        this.lpStatisticsService.startStatisticsBar({
          productId: this.productId,
          unionId: this.unionId,
        });
        this.lpStatisticsService.startStatisticsProducts({
          productId: this.productId,
          unionId: this.unionId,
        });

        this.lpStatisticsService.startStatisticsDiscounts({
          productId: this.productId,
          unionId: this.unionId,
        });
      });
    });
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();

    this.lpStatisticsService.clearAll();
  }

  onChangePeriod(value: TuiDayRange | null) {
    this.statisticsSummaryLoading = true;
    this.lpStatisticsService.startStatisticsSummary({
      productId: this.productId,
      unionId: this.unionId,
      dateFrom: value?.from,
      dateTo: value?.to,
    });

    this.statisticsBarLoading = true;
    this.lpStatisticsService.startStatisticsBar({
      productId: this.productId,
      unionId: this.unionId,
      dateFrom: value?.from,
      dateTo: value?.to,
    });

    this.statisticsProductsLoading = true;
    this.lpStatisticsService.startStatisticsProducts({
      productId: this.productId,
      unionId: this.unionId,
      dateFrom: value?.from,
      dateTo: value?.to,
    });

    this.statisticsDiscountsLoading = true;
    this.lpStatisticsService.startStatisticsDiscounts({
      productId: this.productId,
      unionId: this.unionId,
      dateFrom: value?.from,
      dateTo: value?.to,
    });
  }
}
